import React from "react";
import { CommunityProps } from "../../types";
import { UserMenu, CommunityCard, CommunityHeader } from "..";

type EcoBookCommunityProps = {
  community: CommunityProps;
  loading: boolean | undefined;
  isRefetching?: () => void;
};

const EcoBookCommunity: React.FC<Partial<EcoBookCommunityProps>> = ({
  community,
  loading,
  isRefetching,
  
}) => {
  React.useEffect(() => {
    if(isRefetching){
      isRefetching();
    }
  },[isRefetching])
  return (
    <>
      <UserMenu refetch={isRefetching} community={community} loading={loading} />
      <CommunityCard  community={community} loading={loading} />
      <CommunityHeader refetch={isRefetching} community={community} loadinng={loading} />
    </>
  );
};

export default EcoBookCommunity;
